import type { Translation } from '../types.ts';
import type en from '../en/categories.ts';

export default {
    list: {
        title: 'Categorieën',
        newCategory: 'Nieuwe categorie',
        empty: 'Nog geen categorieën.',
        noSlug: '(geen slug)',
    },
    edit: {
        newCategory: 'Nieuwe categorie',
        created: 'Categorie aangemaakt',
        confirmDelete: 'Categorie "{name}" verwijderen? Subcategorieën komen op het hoofdniveau; producten houden hun andere categorieën.',
        topLevel: '(Hoofdniveau)',
        position: 'Positie',
        parent: 'Bovenliggende categorie',
        menuOrder: 'Volgorde in het menu',
        menuOrderHint: 'Leeg = achteraan in de lijst',
        noImage: 'Geen afbeelding',
        chooseImage: 'Afbeelding kiezen',
        seoIntro: 'Laat een veld leeg voor de standaardwaarde: de categorienaam als titel, de omschrijving als metabeschrijving.',
        seoLocaleFallback: 'Leeg = de waarde van {locale}, daarna de eigen naam van de categorie in deze taal.',
        socialImageHint: 'Leeg = de afbeelding van de categorie',
        robotsSiteNoindex: 'De website is verborgen voor zoekmachines, dus deze categorie stuurt noindex,nofollow, wat hier ook staat. Je wijzigt dit onder Website → Algemeen → Zoekmachines.',
    },
    picker: {
        label: 'Categorie',
        placeholder: 'Categorieën zoeken…',
        loadFailed: 'Categorieën laden is mislukt',
        empty: 'Geen categorieën gevonden.',
        draft: '(concept)',
    },
} satisfies Translation<typeof en>;
